import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import CustomDropdownMenu from "../mui/dropdown";

export default function UserOrderDetail({ menus }) {
  return (
    <div
      className=" mx-2 rounded-md w-full"
      style={{ display: "flex", flexDirection: "column" }}
    >
      {/* <div className="bg-white rounded-md w-40">
        <CustomDropdownMenu
          width={140}
          list={["Defualt", "Price", "Quantity", "Amount"]}
        />
      </div> */}

      <TableContainer
        sx={{ marginInlineStart: "10px", marginTop: "16px" }}
        component={Paper}
      >
        <Table
          sx={{ minWidth: window.innerWidth / 1.4 }}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow>
              <TableCell style={{ fontWeight: "600" }} align="left">
                ID
              </TableCell>
              <TableCell style={{ fontWeight: "600" }} align="left">
                MENU TITLE
              </TableCell>
              <TableCell style={{ fontWeight: "600" }} align="left">
                HALAL
              </TableCell>
              <TableCell style={{ fontWeight: "600" }} align="left">
                PROMO PRICE
              </TableCell>
              <TableCell style={{ fontWeight: "600" }} align="left">
                ORGINAL PRICE
              </TableCell>
              <TableCell style={{ fontWeight: "600" }} align="left">
                SOLD ON
              </TableCell>
              <TableCell style={{ fontWeight: "600" }} align="left">
                VOLUME
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {menus?.map((row, i) => (
              <TableRow
                className="cursor-pointer hover:bg-yellow-200"
                key={i}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {row.menu_id}
                </TableCell>

                <TableCell component="th" scope="row">
                  {row.title}
                </TableCell>

                <TableCell align="left">{row.is_halal==='true'?"Yes":"No"}</TableCell>
                <TableCell align="left">{row.promo + ' RM'}</TableCell>
                <TableCell align="left">{row.price + " RM"}</TableCell>
                <TableCell align="left">{row.is_price_strike==='true'?"Promo Price":"Orginal Price"}</TableCell>
                <TableCell align="left">{row.volume +" Menus"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
